export const formatMapCoordinates = (latitude: number | null | undefined, longitude: number | null | undefined): string => {
    if (latitude == null || longitude == null || !Number.isFinite(latitude) || !Number.isFinite(longitude)) {
        return 'Coordinates unavailable';
    }
    return `${Math.abs(latitude).toFixed(5)}${latitude < 0 ? 'S' : 'N'}, ${Math.abs(longitude).toFixed(5)}${longitude < 0 ? 'W' : 'E'}`;
};

export const activeDrawingPoint = <T>(points: readonly T[]): T | undefined => points.at(-1);

export interface MapSession {
    view: { map: unknown; destroy: () => void };
    track?: { stop: () => void; destroy: () => void };
    legend?: { destroy: () => void };
    handles: { remove: () => void }[];
    removeGraphics: () => void;
}

/** A view owns its SDK resources; the Redux WebMap outlives the view. */
export const createMapSessionCleanup = (session: MapSession): (() => void) => {
    let disposed = false;
    return () => {
        if (disposed) return;
        disposed = true;
        session.handles.forEach((handle) => handle.remove());
        session.track?.stop();
        session.track?.destroy();
        session.legend?.destroy();
        session.removeGraphics();
        session.view.map = null;
        session.view.destroy();
    };
};
